import React, { useState, useRef, useContext, useMemo, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-xPaCrlMu.js';
import useShowError from './hooks/useShowError.js';
import useShowNotify from './hooks/useShowNotify.js';
import useWindowSize from './hooks/useWindowSize.js';
import { getStockInfo, isBackorderAllowed } from './utils/product.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import useItemListName from './hooks/useItemListName.js';
import { getCartSessionId, isCartSessionValid, checkCartSessionIdValidity } from './utils/cart.js';
import { getProductDiscount } from './utils/saleFlag.js';
import { getPrices } from './utils/price.js';
import { processErrorMessage } from './utils/error.js';
import { g as getBreadcrumbs, a as getProductImages, c as calculateStikyTopProduct } from './helper-qZTqmbEO.js';
import Button from './components/Button/index.js';
import Breadcrumbs from './components/Breadcrumbs/index.js';
import WishlistButton from './components/WishlistButton/index.js';
import JustAddedProducts from './components/JustAddedProducts/index.js';
import ImagesCarousel from './components/ImagesCarousel/index.js';
import { C as CarouselVerticalComponent } from './ImagesCarouselVertical-b9BRMREW.js';
import { S as SaleFlag } from './SaleFlag-uqbhEU3Y.js';
import { P as Prices } from './Prices-J1SqTpik.js';
import { C as Counter } from './Counter-VXuTWVIz.js';
import { U as UpsellProducts } from './UpsellProducts-Wc3lCklO.js';
import { I as ItemCopy } from './ItemCopy-A-crjZxm.js';
import { R as RelatedProducts } from './RelatedProducts-9tDufU_z.js';
import { E as EcoFee } from './EcoFee-Ep6rIIu6.js';
import { toggleModal } from './store/modal/index.js';
import './types/index.js';
import './checkout-Ee1eEXQH.js';
import './menu-0TyOg98i.js';
import './product-_pRduMz7.js';
import { M as ModalType } from './modal-6vnX5SO3.js';
import { c as classnames } from './index-2586sEvh.js';
import { A as AlmaBanner } from './AlmaBanner-qWjGjPhU.js';

const SimpleProduct = ({ product, wishlistButton, outsideHeading = false, extraContent, accordionExtraContent, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { locale } = useRouter();
    const showNotify = useShowNotify();
    const showErrorNotify = useShowError();
    const maxQty = 99;
    const [counterValue, setCounterValue] = useState(1);
    const [addonCounterValue, setAddonCounterValue] = useState(1);
    const [justAddedData, setJustAddedData] = useState(null);
    const [selectedRelatedProductsSku, setSelectedRelatedProductsSku] = useState([]);
    const [isAdding, setIsAdding] = useState(false);
    const [addOnOutStockNotified, setAddOnaddOnOutStockNotified] = useState(false);
    const [hasRetriedAddToCart, setHasRetriedAddToCart] = useState(false);
    const openModalRef = useRef(null);
    const imageWrapRef = useRef(null);
    const windowSize = useWindowSize();
    const itemListName = useItemListName();
    const { useDispatch, thunks: { cart: { getCart, addProduct }, }, data: { siteConfig: { product: { counterButtons = false, headingInProductImage = false, itemCopyDesktop = 'tabs', verticalCarousel = false, breadCrumbPosition = 'top', alignCounterWithCartBtn = false, stickConfigBlock = false, disableDefaultYmal = false, } = {}, cart: { useCartDrawer = false } = {}, accorTagging: { accorTaggingEnabled = false } = {}, promo: { displaySaleFlag = false, discount: promoDiscount = '', productsSaleExcludeList = [], } = {}, noZeroAfterDecimal = false, }, }, } = useContext(CoreContext);
    const dispatch = useDispatch();
    const showError = useShowError();
    const prices = useMemo(() => getPrices(product.price_range, locale, noZeroAfterDecimal), [product]);
    const breadcrumbItems = getBreadcrumbs(product, locale);
    const productImages = getProductImages(product);
    const stockInfo = getStockInfo(product.backorder_status, product.stock_status, Number(product.quantity), t);
    const addonStockInfo = product.related_products.length &&
        getStockInfo((_a = product.related_products[0]) === null || _a === void 0 ? void 0 : _a.backorder_status, (_b = product.related_products[0]) === null || _b === void 0 ? void 0 : _b.stock_status, Number((_c = product.related_products[0]) === null || _c === void 0 ? void 0 : _c.quantity), t);
    const productPromoDiscount = getProductDiscount(promoDiscount, product, productsSaleExcludeList);
    const onRelatedProductClick = (sku) => {
        if (selectedRelatedProductsSku.includes(sku)) {
            // Remove
            setSelectedRelatedProductsSku(prevState => prevState.filter(prevSku => prevSku !== sku));
        }
        else {
            // Add
            setSelectedRelatedProductsSku(prevState => [...prevState, sku]);
        }
    };
    const getRelatedProductsPayload = () => selectedRelatedProductsSku.map(sku => ({
        data: {
            quantity: Number(addonCounterValue),
            sku,
        },
    }));
    const getPayload = () => [
        {
            data: {
                quantity: Number(counterValue),
                sku: product.sku,
            },
        },
        ...getRelatedProductsPayload(),
    ];
    const handleAddToCart = async () => {
        setIsAdding(true);
        const payload = getPayload();
        const resultAction = await dispatch(addProduct({ simpleProducts: payload, accorTaggingEnabled, itemListName }));
        if (addProduct.fulfilled.match(resultAction)) {
            if (!useCartDrawer) {
                setJustAddedData(resultAction.payload);
                // Run getCart() to update MiniShoppingCart popup data
                dispatch(getCart({ cart_id: getCartSessionId(), accorTaggingEnabled }));
            }
            else {
                await dispatch(getCart({ cart_id: getCartSessionId(), accorTaggingEnabled }));
                dispatch(toggleModal(ModalType.ShoppingCart));
            }
        }
        else {
            const error = processErrorMessage(resultAction.payload.errorMessage, t);
            // If cart session is invalid, retry only once
            if (!isCartSessionValid(error) && !hasRetriedAddToCart) {
                checkCartSessionIdValidity(error);
                handleAddToCart();
                setHasRetriedAddToCart(true);
                return;
            }
            showError(error);
        }
        setIsAdding(false);
    };
    const closeHandler = () => {
        setJustAddedData(null);
        if (openModalRef.current) {
            openModalRef.current.focus();
        }
    };
    useEffect(() => {
        const allowBackorder = product.backorder_status === 'Allow Qty Below 0';
        const mainMaxValue = allowBackorder ? maxQty : Math.min(maxQty, stockInfo.qty);
        const mainMaxReached = counterValue > mainMaxValue && (stockInfo.qty > 0 || allowBackorder);
        const addonMaxReached = (addonStockInfo === null || addonStockInfo === void 0 ? void 0 : addonStockInfo.qty) < counterValue;
        const updateCounterValues = () => {
            setCounterValue(mainMaxValue);
            setAddonCounterValue(mainMaxValue);
            if (mainMaxValue === maxQty) {
                showErrorNotify(t('$common.$validation.maximumQuantity'));
            }
            else {
                showNotify(tValidation('outStockReduceQtyForName', { productName: product.name }));
            }
        };
        const updateAddonCounterValue = (qty, productName) => {
            setAddonCounterValue(qty);
            if (!addOnOutStockNotified) {
                showNotify(tValidation('outStockReduceQtyForName', { productName }));
            }
            setAddOnaddOnOutStockNotified(true);
        };
        if (stockInfo.availableForSale && !isBackorderAllowed(product === null || product === void 0 ? void 0 : product.backorder_status)) {
            const selected = product.related_products
                .filter(item => selectedRelatedProductsSku.includes(item.sku))
                .sort((a, b) => a.quantity - b.quantity)[0];
            const isSelectedOutofStock = (selected === null || selected === void 0 ? void 0 : selected.quantity) < counterValue;
            if (!mainMaxReached && !isSelectedOutofStock) {
                setAddonCounterValue(counterValue);
            }
            if (isSelectedOutofStock && (selected === null || selected === void 0 ? void 0 : selected.quantity) !== addonCounterValue) {
                updateAddonCounterValue(selected === null || selected === void 0 ? void 0 : selected.quantity, selected === null || selected === void 0 ? void 0 : selected.name);
            }
            else if (!addOnOutStockNotified &&
                selectedRelatedProductsSku.length &&
                addonMaxReached &&
                (addonStockInfo === null || addonStockInfo === void 0 ? void 0 : addonStockInfo.qty) !== counterValue) {
                updateAddonCounterValue(addonStockInfo === null || addonStockInfo === void 0 ? void 0 : addonStockInfo.qty, product.related_products[0].name);
            }
        }
        if (mainMaxReached) {
            updateCounterValues();
        }
    }, [counterValue, selectedRelatedProductsSku]);
    useEffect(() => {
        if (stickConfigBlock) {
            calculateStikyTopProduct(imageWrapRef.current);
            window.addEventListener('resize', () => calculateStikyTopProduct(imageWrapRef.current));
        }
    }, []);
    const blocNameImage = `product image ${product.name}`;
    return (React.createElement("div", { className: classnames('clearfix', 'product-page', 'product-simple', {
            'product-vertical-carousel': verticalCarousel,
        }) },
        React.createElement("section", null,
            breadCrumbPosition === 'top' && (React.createElement(Breadcrumbs, { items: breadcrumbItems, currentItem: product.name })),
            React.createElement("div", { className: "product" },
                outsideHeading && !headingInProductImage && React.createElement("h1", null, product.name),
                React.createElement("div", { className: "product-image-wrap", ref: imageWrapRef },
                    React.createElement(SaleFlag, { show: displaySaleFlag, discount: productPromoDiscount }),
                    verticalCarousel && windowSize.width > 768 ? (React.createElement("div", { className: "product-slider-wrapper vertical-carousel", "data-event-name": "bloc_interact", "data-bloc-name": blocNameImage },
                        React.createElement(CarouselVerticalComponent, { items: productImages, thumbnailImage: ((_d = product.thumbnail) === null || _d === void 0 ? void 0 : _d.url) || null, title: product.name }))) : (React.createElement("div", { className: "product-slider-wrapper", "data-event-name": "bloc_interact", "data-bloc-name": blocNameImage },
                        React.createElement(ImagesCarousel, { items: productImages, thumbnailImage: ((_e = product.thumbnail) === null || _e === void 0 ? void 0 : _e.url) || null, title: product.name }))),
                    React.createElement("div", { className: "product-config-wrapper" },
                        React.createElement("div", { className: "product-config" },
                            breadCrumbPosition === 'product-config' && (React.createElement(Breadcrumbs, { items: breadcrumbItems, currentItem: product.name })),
                            React.createElement("div", { className: "inner-wrapper" },
                                !outsideHeading && !headingInProductImage && (React.createElement("div", { className: "product-config-row product-config-name" },
                                    React.createElement("h1", { "data-name_en": product.name_en.product_name, className: "font-sub-heading", "data-event-name": "bloc_interact", "data-bloc-name": `product name ${product.name}` }, ((_f = product.product_subtitle) === null || _f === void 0 ? void 0 : _f.trim())
                                        ? `${product.name} - ${product.product_subtitle}`
                                        : product.name),
                                    wishlistButton && (React.createElement("div", { className: "product-config-wishlist" },
                                        React.createElement(WishlistButton, { product: product }))))),
                                React.createElement("div", { className: "product-config-column product-config-price" },
                                    React.createElement(Prices, { show: true, prices: prices, className: "product-config-prices" })),
                                stockInfo.message && (React.createElement("p", { role: "alert", className: "info-ui", id: "stockInfoMessage" }, stockInfo.message)),
                                React.createElement("div", { className: "product-wrap-addcart" },
                                    !!product.related_products.length && (React.createElement(RelatedProducts, { items: product.related_products, quantityCounter: addonCounterValue, parentProductType: product.type_id, selectedRelatedProductsSku: selectedRelatedProductsSku, onRelatedProductClick: onRelatedProductClick })),
                                    !alignCounterWithCartBtn && (React.createElement(React.Fragment, null,
                                        React.createElement(Counter, { value: counterValue, setValue: setCounterValue, maxCount: Math.min(product.max_qty_on_cart, maxQty), disabled: isAdding || !stockInfo.availableForSale || stockInfo.qty === 0, counterButtons: counterButtons }),
                                        React.createElement("br", null),
                                        React.createElement(Button, { buttonRef: openModalRef, className: "product-add-to-bag base-btn bg-red", isLoading: isAdding, disabled: !stockInfo.availableForSale || stockInfo.qty === 0, disabledMsg: stockInfo.message, onClick: handleAddToCart }, tButton('addToCart')))),
                                    alignCounterWithCartBtn && (React.createElement("div", { className: "product-wrap-addcart-btn-and-qty" },
                                        React.createElement(Counter, { value: counterValue, setValue: setCounterValue, maxCount: Math.min(product.max_qty_on_cart, maxQty), disabled: isAdding || !stockInfo.availableForSale || stockInfo.qty === 0, counterButtons: counterButtons }),
                                        React.createElement(Button, { buttonRef: openModalRef, className: "product-add-to-bag base-btn bg-red", isLoading: isAdding, disabled: !stockInfo.availableForSale || stockInfo.qty === 0, disabledMsg: stockInfo.message, onClick: handleAddToCart }, tButton('addToCart')))),
                                    React.createElement(AlmaBanner, { prices: prices }))),
                            React.createElement(EcoFee, { fee: product === null || product === void 0 ? void 0 : product.eco_fee, locale: locale }),
                            itemCopyDesktop === 'accordion' && (React.createElement(ItemCopy, { description: product.description.html, information: product.information, productTab3: product.additional_tab_one_content, productTab4: product.additional_tab_two_content, accordionExtraContent: accordionExtraContent })),
                            itemCopyDesktop === 'tabs' && accordionExtraContent && (React.createElement("div", { className: "accordion-extra-content", dangerouslySetInnerHTML: {
                                    __html: accordionExtraContent,
                                } }))))),
                itemCopyDesktop !== 'accordion' && (React.createElement(ItemCopy, { description: product.description.html, information: product.information, productTab3: product.additional_tab_one_content, productTab4: product.additional_tab_two_content, accordionExtraContent: accordionExtraContent })),
                extraContent,
                !!((_g = product.upsell_products) === null || _g === void 0 ? void 0 : _g.length) &&
                    !disableDefaultYmal &&
                    product.upsell_products.some(item => item.stock_status !== 'OUT_OF_STOCK') && (React.createElement(UpsellProducts, { items: product.upsell_products })))),
        justAddedData && React.createElement(JustAddedProducts, { data: justAddedData, onClose: closeHandler })));
};

export { SimpleProduct as S };
//# sourceMappingURL=SimpleProduct-Wwqx56iD.js.map
